// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"152":"2745750c","678":"35a60f79"}[chunkId] + ".js";
};